(() => {
  'use strict';
  const configNode = document.getElementById('PepitaConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const storageKey = 'la-pepita:favorite-handles:v1';
  const root = (config.root || '/').replace(/\/?$/, '/');
  const productPath = handle => `${root}products/${encodeURIComponent(handle)}`;
  const safeHandle = value => typeof value === 'string' && /^[a-z0-9-]+$/.test(value);
  const readStorage = (storage, key, fallback) => {
    try { return JSON.parse(storage.getItem(key)) ?? fallback; } catch { return fallback; }
  };
  const writeStorage = (storage, key, value) => {
    try { storage.setItem(key, JSON.stringify(value)); } catch { }
  };
  let favorites;
  try { favorites = readStorage(localStorage, storageKey, []); } catch { favorites = []; }
  favorites = Array.isArray(favorites) ? [...new Set(favorites.filter(safeHandle))].slice(0, 100) : [];
  let favoriteLimit = 24;
  let favoriteRender = 0;
  const status = message => {
    const node = document.querySelector('[data-pepita-status]');
    if (node) node.textContent = message;
  };
  const openDialog = dialog => {
    if (dialog && !dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
  };
  const updateFavorites = () => {
    document.querySelectorAll('[data-pepita-favorite]').forEach(button => {
      const active = favorites.includes(button.dataset.pepitaFavorite);
      const text = active ? config.remove : config.add;
      if (button.getAttribute('aria-pressed') !== String(active)) button.setAttribute('aria-pressed', String(active));
      if (button.getAttribute('aria-label') !== text) button.setAttribute('aria-label', text);
      const label = button.querySelector('[data-pepita-favorite-label]');
      if (label && label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('[data-pepita-favorite-count]').forEach(node => {
      if (node.textContent !== String(favorites.length)) node.textContent = String(favorites.length);
      node.hidden = favorites.length === 0;
    });
  };
  const makeNode = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const renderFavorites = async () => {
    const content = document.querySelector('[data-pepita-favorites-content]');
    if (!content) return;
    const revision = ++favoriteRender;
    content.replaceChildren(makeNode('p', favorites.length ? config.loading : config.empty));
    if (!favorites.length) return;
    const handles = favorites.slice(0, favoriteLimit);
    const cards = new Array(handles.length);
    let index = 0;
    const worker = async () => {
      while (index < handles.length) {
        const current = index++;
        const handle = handles[current];
        const article = makeNode('article');
        const link = makeNode('a');
        link.href = productPath(handle);
        try {
          const response = await fetch(`${productPath(handle)}.js`, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('product unavailable');
          const product = await response.json();
          if (product.featured_image) {
            const src = new URL(product.featured_image, location.origin);
            if (src.protocol === 'https:' || src.protocol === 'http:') {
              src.searchParams.set('width', '480');
              const img = makeNode('img');
              img.src = src.href; img.alt = product.title; img.loading = 'lazy'; img.width = 480; img.height = 600;
              link.append(img);
            }
          }
          link.append(makeNode('h3', product.title));
          const currency = config.currency || 'EUR';
          link.append(makeNode('p', new Intl.NumberFormat(config.locale || 'es-ES', { style: 'currency', currency }).format(product.price / 100)));
        } catch {
          link.append(makeNode('p', config.error), makeNode('span', config.view));
        }
        const remove = makeNode('button', '♥', 'pepita-favorite');
        remove.type = 'button'; remove.dataset.pepitaFavorite = handle; remove.setAttribute('aria-label', config.remove); remove.setAttribute('aria-pressed', 'true');
        article.append(link, remove); cards[current] = article;
      }
    };
    await Promise.all([worker(), worker(), worker()]);
    if (revision !== favoriteRender) return;
    content.replaceChildren(...cards);
    if (favorites.length > favoriteLimit) {
      const more = makeNode('button', '+', 'button button--secondary');
      more.type = 'button'; more.setAttribute('aria-label', config.view); more.dataset.pepitaMoreFavorites = 'true';
      content.append(more);
    }
  };
  const enhanceGuides = (scope = document) => {
    scope.querySelectorAll('[data-lunea-size-guide]').forEach(guide => {
      if (guide.querySelector('[data-pepita-units]')) return;
      const controls = makeNode('div', undefined, 'pepita-unit-controls');
      controls.dataset.pepitaUnits = 'true'; controls.setAttribute('role', 'group'); controls.setAttribute('aria-label', config.units);
      [['cm', config.cm], ['in', config.inches]].forEach(([unit, label]) => {
        const button = makeNode('button', label); button.type = 'button'; button.dataset.pepitaUnit = unit; button.setAttribute('aria-pressed', String(unit === 'cm')); controls.append(button);
      });
      guide.prepend(controls);
    });
  };
  const setUnits = (guide, unit) => {
    guide.querySelectorAll('[data-cm]').forEach(cell => {
      const raw = cell.dataset.cm;
      cell.textContent = unit === 'cm' ? raw : raw.replace(/\d+(?:[.,]\d+)?/g, value => (Number(value.replace(',', '.')) / 2.54).toFixed(1));
    });
    guide.querySelectorAll('[data-unit-label]').forEach(node => { node.textContent = unit === 'cm' ? config.cm : config.inches; });
    guide.querySelectorAll('[data-pepita-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pepitaUnit === unit)));
  };
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-pepita-close]');
    if (close) close.closest('dialog')?.close();
    const wishlist = event.target.closest('[data-pepita-wishlist-open]');
    if (wishlist) { openDialog(document.getElementById('PepitaFavorites')); renderFavorites(); }
    const favorite = event.target.closest('[data-pepita-favorite]');
    if (favorite && safeHandle(favorite.dataset.pepitaFavorite)) {
      event.preventDefault();
      const handle = favorite.dataset.pepitaFavorite;
      if (!favorites.includes(handle) && favorites.length >= 100) { status(config.limit); return; }
      favorites = favorites.includes(handle) ? favorites.filter(value => value !== handle) : [handle, ...favorites];
      try { writeStorage(localStorage, storageKey, favorites); } catch { }
      updateFavorites();
      if (document.getElementById('PepitaFavorites')?.open) renderFavorites();
    }
    if (event.target.closest('[data-pepita-favorites-clear]')) {
      favorites = []; try { writeStorage(localStorage, storageKey, favorites); } catch { }
      updateFavorites(); renderFavorites();
    }
    if (event.target.closest('[data-pepita-more-favorites]')) { favoriteLimit += 24; renderFavorites(); }
    const sizeOpen = event.target.closest('[data-pepita-size-open]');
    if (sizeOpen) {
      const guide = sizeOpen.closest('.product')?.querySelector('[data-lunea-size-guide]') || document.querySelector('product-info [data-lunea-size-guide]');
      const content = document.querySelector('[data-pepita-size-content]');
      if (guide && content) {
        const clone = guide.cloneNode(true);
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        content.replaceChildren(clone); enhanceGuides(content); openDialog(document.getElementById('PepitaSizeGuide'));
      }
    }
    const unit = event.target.closest('[data-pepita-unit]');
    if (unit) setUnits(unit.closest('[data-lunea-size-guide]'), unit.dataset.pepitaUnit);
  });
  document.querySelectorAll('.pepita-dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  }));
  const initWheel = scope => {
    scope.querySelectorAll('[data-pepita-wheel]').forEach(wheel => {
      if (wheel.dataset.initialized) return;
      wheel.dataset.initialized = 'true';
      const preview = wheel.dataset.preview === 'true' || Boolean(window.Shopify?.designMode);
      const allPrizes = JSON.parse(wheel.querySelector('[data-pepita-wheel-prizes]').textContent);
      const prizes = allPrizes.filter(prize => preview || prize.code);
      if (!prizes.length) return;
      const dialog = wheel.querySelector('dialog');
      const spin = wheel.querySelector('[data-pepita-spin]');
      const entry = wheel.querySelector('[data-pepita-wheel-entry]');
      const result = wheel.querySelector('[data-pepita-wheel-reward]');
      const wheelStatus = wheel.querySelector('[data-pepita-wheel-status]');
      const field = wheel.querySelector('[data-pepita-reward-field]');
      const key = 'la-pepita:wheel:v1';
      let state = null;
      try { state = readStorage(sessionStorage, key, null); } catch { }
      if (!state || Date.now() - state.time > 86400000) state = null;
      let prize = state && prizes.find(item => item.index === state.index && item.code === state.code);
      let spinning = false;
      const save = claimed => {
        if (preview || !prize) return;
        state = { index: prize.index, code: prize.code, time: Date.now(), claimed };
        try { writeStorage(sessionStorage, key, state); } catch { }
      };
      const showEntry = () => {
        if (!prize) return;
        entry.hidden = false; spin.hidden = true; wheelStatus.textContent = prize.label;
        if (field) field.value = `${prize.label} · ${prize.code}`;
      };
      const showReward = () => {
        if (!prize || preview) return;
        entry.hidden = true; spin.hidden = true; result.hidden = false;
        wheel.querySelector('[data-pepita-reward-label]').textContent = prize.label;
        wheel.querySelector('[data-pepita-reward-code]').textContent = prize.code;
        wheel.querySelector('[data-pepita-reward-link]').href = `${root}discount/${encodeURIComponent(prize.code)}?redirect=${encodeURIComponent(root + 'collections/toda-la-coleccion')}`;
      };
      wheel.querySelector('[data-pepita-wheel-open]').addEventListener('click', () => openDialog(dialog));
      spin.addEventListener('click', () => {
        if (spinning || prize) return;
        spinning = true; spin.disabled = true;
        const random = new Uint32Array(1); crypto.getRandomValues(random);
        prize = prizes[Math.floor(random[0] / 4294967296 * prizes.length)];
        wheel.querySelector('[data-pepita-wheel-disc]').style.transform = `rotate(${1800 + (360 - prize.index * 90) % 360}deg)`;
        const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 4100;
        setTimeout(() => { spinning = false; save(false); showEntry(); entry.querySelector('input[type=email]')?.focus({ preventScroll: true }); }, delay);
      });
      const phone = wheel.querySelector('[data-pepita-phone]');
      phone?.addEventListener('input', () => {
        const value = phone.value.trim();
        const digits = value.replace(/\D/g, '');
        const valid = /^[+()\d\s.-]+$/.test(value) && digits.length >= 8 && digits.length <= 15;
        phone.setCustomValidity(valid ? '' : wheel.dataset.phoneError);
      });
      wheel.querySelector('form')?.addEventListener('submit', event => {
        if (preview) { event.preventDefault(); wheelStatus.textContent = wheel.dataset.previewMessage; return; }
        if (!prize) { event.preventDefault(); return; }
        phone?.dispatchEvent(new Event('input'));
        if (!event.target.reportValidity()) event.preventDefault();
      });
      if (prize) { showEntry(); if (state?.claimed) showReward(); }
      if (wheel.querySelector('[data-pepita-wheel-success]') && prize && !preview) { save(true); showReward(); openDialog(dialog); }
      if (wheel.querySelector('[data-pepita-wheel-errors]')) { showEntry(); openDialog(dialog); }
      if (!preview && !state && wheel.dataset.auto === 'true') {
        let shown = false;
        try { shown = sessionStorage.getItem('la-pepita:wheel-seen') === 'yes'; } catch { }
        if (!shown) document.addEventListener('pointerdown', () => setTimeout(() => {
          if (!document.querySelector('dialog[open], .drawer.active')) {
            openDialog(dialog); try { sessionStorage.setItem('la-pepita:wheel-seen', 'yes'); } catch { }
          }
        }, 6000), { once: true });
      }
    });
  };
  updateFavorites(); enhanceGuides(); initWheel(document);
  document.addEventListener('shopify:section:load', () => { updateFavorites(); enhanceGuides(); initWheel(document); });
  window.addEventListener('storage', event => {
    if (event.key !== storageKey) return;
    try { const values = JSON.parse(event.newValue || '[]'); favorites = Array.isArray(values) ? [...new Set(values.filter(safeHandle))].slice(0, 100) : []; } catch { favorites = []; }
    updateFavorites();
  });
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; updateFavorites(); enhanceGuides(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
